import React from "react";

import {cn} from "@isudio/utils";

const RowFlex: React.FC<React.PropsWithChildren<{
  className?: string
}>> = ({
         className,
         children,
       }) => (
  <div
    className={cn("row w-full gap-4 flex flex-col sm:flex-row", className)}>
    {children}
  </div>
);

RowFlex.displayName = "RowFlex";
export {RowFlex};